exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".waiting-room-sidebar--2bfEDblBMMz5RLd_C3o6KY {\n  cursor: pointer;\n  flex-shrink: 0;\n}\n", ""]);

// exports
exports.locals = {
	"participantStatus": "waiting-room-sidebar--2bfEDblBMMz5RLd_C3o6KY",
	"participantStatus": "waiting-room-sidebar--2bfEDblBMMz5RLd_C3o6KY"
};